module.exports = __webpack_public_path__ + "img/img-20.d99fb034.webp";